import { useState } from 'react';

import { Button } from '@/components/ui/button';

/**
 * 文字列をクリップボードへ写す。
 *
 * トークンや設定スニペットを手で選択させると取りこぼすので、
 * コピーさせたいブロックには必ずこれを添える。
 * 押した直後だけラベルが変わる。
 */
export function CopyButton({ value, label = 'コピー' }: { value: string; label?: string }) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // 非セキュアオリジンや権限拒否では使えない。
      // 手で選択してコピーする経路は残っているので、黙って諦める。
      return;
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  }

  return (
    <Button variant="ghost" onClick={copy} aria-live="polite">
      {copied ? 'コピーしました' : label}
    </Button>
  );
}
